export const Colors = {
  // Principais - Com contraste WCAG AAA
  yellow: '#FFD700',      // Amarelo mais visível
  gold: '#B8860B',        // Ouro mais escuro para contraste
  dark: '#0A0A0A',        // Preto profundo
  white: '#FFFFFF',       // Branco puro
  
  // Neutros
  gray100: '#F8F9FA',     // Fundo claro
  gray200: '#E9ECEF',     // Border claro
  gray300: '#DEE2E6',     // Divider
  gray600: '#6C757D',     // Texto secundário
  gray800: '#212529',     // Texto forte
  
  // Estados
  success: '#2D7D4A',     // Verde acessível
  error: '#C20000',       // Vermelho vibrante
  warning: '#FF8C00',     // Laranja acessível
  info: '#0066CC',        // Azul acessível
  
  // Semântico
  background: '#0A0A0A',
  surface: '#1A1A1A',
  surfaceLight: '#2D2D2D',
  textPrimary: '#FFFFFF',
  textSecondary: '#B0B0B0',
  textTertiary: '#808080',
  border: '#404040',
  borderLight: '#606060',
}